import { Link } from "react-router-dom";
import { IDS } from "@/lib/testIds";

export function SiteFooter() {
  return (
    <footer
      data-testid={IDS.footer}
      className="border-t border-muted-line/70 bg-stone-soft"
    >
      <div className="mx-auto max-w-4xl px-6 py-10">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="max-w-md text-[13px] leading-relaxed text-muted">
            KATLAS Cierge Design Studio — invited discovery test. An early testing
            environment. No account or payment is required.
          </p>
          <nav className="flex items-center gap-6 text-[13px] text-ink-soft">
            <Link
              to="/privacy"
              data-testid={IDS.privacyLink}
              className="underline-offset-4 transition-colors hover:text-teal hover:underline"
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              data-testid={IDS.termsLink}
              className="underline-offset-4 transition-colors hover:text-teal hover:underline"
            >
              Terms
            </Link>
            <Link
              to="/contact"
              data-testid={IDS.contactLink}
              className="underline-offset-4 transition-colors hover:text-teal hover:underline"
            >
              Contact
            </Link>
          </nav>
        </div>
        <p className="mt-6 border-t border-muted-line/60 pt-5 text-[11px] uppercase tracking-[0.14em] text-muted/80">
          Invited trial information — draft for testing
        </p>
      </div>
    </footer>
  );
}
